import { TFunction } from 'react-i18next';
import { ColumnsType } from 'antd/es/table';
import { StyledBadge } from '@/components';
import { Button } from '@/ui';
import { ICashRegister } from '@/models/financialSettings.model';

type TGetCashRegisterColumns = {
  t: TFunction;
  onDelete: (item: ICashRegister) => void;
  onUpdate: (item: ICashRegister) => void;
  canManage: boolean;
};

export const getCashRegisterColumns = ({
  t,
  onDelete,
  onUpdate,
  canManage,
}: TGetCashRegisterColumns): ColumnsType<ICashRegister> => {
  const yesNo = (value: boolean) => <StyledBadge $isActive={value}>{value ? t('yes') : t('no')}</StyledBadge>;

  return [
    {
      title: t('column_name'),
      dataIndex: 'name',
      key: 'name',
      render: (name) => <span>{name}</span>,
    },
    {
      title: t('column_legal_type'),
      dataIndex: 'legal_type',
      key: 'legal_type',
      render: (legalType: string) => <span>{t(`legal_type_${legalType}`)}</span>,
    },
    {
      title: t('column_is_virtual'),
      dataIndex: 'is_virtual',
      key: 'is_virtual',
      render: (isVirtual) => yesNo(isVirtual),
    },
    {
      title: t('column_cashier'),
      dataIndex: 'cashier',
      key: 'cashier',
      render: (_, record) => <span>{record.cashier?.login ?? '—'}</span>,
    },
    {
      title: t('column_license_key'),
      dataIndex: 'has_license_key',
      key: 'has_license_key',
      render: (hasKey) => yesNo(hasKey),
    },
    {
      title: t('column_status'),
      dataIndex: 'is_active',
      key: 'is_active',
      render: (isActive) => yesNo(isActive),
    },
    ...(canManage
      ? [
          {
            title: t('column_actions'),
            key: 'actions',
            render: (_: unknown, record: ICashRegister) => (
              <>
                <Button type="link" onClick={() => onUpdate(record)}>
                  {t('action_edit')}
                </Button>
                <Button type="link" onClick={() => onDelete(record)}>
                  {t('action_delete')}
                </Button>
              </>
            ),
          },
        ]
      : []),
  ];
};
